export default __webpack_public_path__ + "static/media/DO.5cc5645c.svg";